import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getAccordionAnchorById } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionSelectors";

export const useIsAccordionOpen = (anchorId: string) => {
    return useAppSelector(state => getAccordionAnchorById(state, anchorId))?.isOpen;
};
